export const SEARCH_DEBOUNCE_TIME_MS = 100;
export const SNACK_BAR_DEFAULT_TIME_MS = 4000;
export const SNACK_BAR_HORIZONTAL_POSITION = 'left';
export const SNACK_BAR_BASE_CLASS = 'app-snackbar';
// The duration and transition curve are copied from global.scss.
export const DEFAULT_TRANSITION_CURVE = 'cubic-bezier(0.35, 0, 0.25, 1)';
export const DEFAULT_ANIMATION_TIMING = `0.28s ${DEFAULT_TRANSITION_CURVE}`;
export const SHORT_ANIMATION_TIMING = `0.18s ${DEFAULT_TRANSITION_CURVE}`;
